/**********************************************************************************************************
 *   STYLE
 **********************************************************************************************************/
import styled from 'styled-components'
import { Form } from 'formik'
import { Badge, Fade, Tabs, Theme } from '@nexigendigital/nxui'
import { CheckIcon } from '@heroicons/react/solid'

export const Invoice = {
    Header: styled.header`
         display: flex;
         flex-direction: row;
         justify-content: space-between;
         align-items: center;
         padding: 1rem;
         color: ${props => (props.theme['text--100'])};
         background-color: ${props => (props.theme['background--000'])};
         ${Theme.Functions.setFont('Inter', 400)};
 
         ${props => Theme.Functions.mediaBreakUp(props.theme['breakpoints-sm'])} {
             padding: 1.5rem;
         }
     ;
 
         strong {
             color: ${props => (props.theme['text--300'])};
             ${Theme.Functions.setFont('Inter', 500)};
         }
     `,
    Status: styled(Badge)``,
    Details: styled.div`
         display: flex;
         flex-wrap: wrap;
         width: 100%;
     `,
    Row: styled.div`
         display: inline-flex;
         flex-wrap: wrap;
         width: 100%;
         min-width: 280px;
 
         &:last-of-type {
             border-radius: 0 0 16px 16px;
         }
     ;
     `,
    Column: {
        Base: styled.div`
             display: inline-flex;
             flex: 1 1 0;
             background-color: ${props => (props.theme['background--000'])};
             min-width: 280px;
             padding: 18px 24px;
             box-shadow: 1px 0 0 0 ${props => (props.theme['gray--100'])},
             0 1px 0 0 ${props => (props.theme['gray--100'])},
             1px 1px 0 0 ${props => (props.theme['gray--100'])},
             1px 0 0 0 ${props => (props.theme['gray--100'])} inset,
             0 1px 0 0 ${props => (props.theme['gray--100'])} inset;
 
             &:first-of-type {
                 box-shadow: 1px 0 0 0 ${props => (props.theme['gray--100'])},
                 0 1px 0 0 ${props => (props.theme['gray--100'])},
                 1px 1px 0 0 ${props => (props.theme['gray--100'])},
                 0 0 0 0 ${props => (props.theme['gray--100'])} inset,
                 0 1px 0 0 ${props => (props.theme['gray--100'])} inset;
             };
 
             ${props => Theme.Functions.mediaBreakDown(props.theme['breakpoints-sm'])} {
                 height: 55px;
                 padding: 10px 15px;
                 flex-direction: row;
             };
         `,
        Render: styled.div`
             display: inline-flex;
             justify-content: flex-end;
             align-items: center;
             width: 100%;
             text-align: right;
             color: ${props => (props.theme['text--300'])};
             font-size: 14px;
             letter-spacing: -0.25px;
             ${Theme.Functions.setFont('Inter', 500)};
         `,
        Title: styled.div`
             display: inline-flex;
             align-items: center;
             height: 100%;
             min-width: 100px;
             margin-right: 10px;
             color: ${props => (props.theme['text--100'])};
             font-size: 14px;
             letter-spacing: -0.25px;
             ${Theme.Functions.setFont('Inter', 400)};
 
             ${props => Theme.Functions.mediaBreakDown(props.theme['breakpoints-sm'])} {
                 margin-right: 15px;
             }
         `
    },
    Breakdown: styled.div`
         border-bottom: 1px solid ${props => (props.theme['border--100'])};
     `,
    Actions: styled.div`
         display: flex;
         flex-direction: column;
         justify-content: space-between;
         align-items: center;
         padding: 1rem;
 
         > div {
             display: flex;
             flex-direction: row;
         }
 
         ${props => Theme.Functions.mediaBreakUp(props.theme['breakpoints-sm'])} {
             flex-direction: row;
         }
     `,
    Footer: styled.footer`
         display: flex;
         flex-direction: row;
         background-color: ${props => (props.theme['background--000'])};
 
         ${props => Theme.Functions.mediaBreakDown(props.theme['breakpoints-sm'])} {
             flex-direction: column;
         }
     `
}

export const Payment = {
    Base: styled.div`
         display: flex;
         flex-direction: column;
         align-items: flex-start;
         justify-content: center;
         width: 100%;
         padding: 20px;
         background-color: ${props => (props.theme['background--000'])};
 
         ${props => Theme.Functions.mediaBreakDown(props.theme['breakpoints-sm'])} {
             padding: 20px 20px 0;
         }
     `,
    Header: styled.div`
         display: flex;
         flex-direction: column;
         padding-bottom: 20px
     `,
    Title: styled.div`
         font-size: 14px;
         color: ${props => (props.theme['text--300'])};
         ${Theme.Functions.setFont('Inter', 700)};
     `,
    Description: styled.div`
         font-size: 13px;
         color: ${props => (props.theme['text--100'])};
         ${Theme.Functions.setFont('Inter', 400)};
     `,
    Body: styled.div`
         width: 100%;
     `,
    Tabs: styled(Tabs)`
         border: none;
         box-shadow: none;
     `,
    Form: styled(Form)`
     width: 100%;
         margin-top: 15px;
     `,
    Fade: styled(Fade)`
         align-items: flex-start
     `
}

export const Breakdown = {
    Title: styled.div`
         display: flex;
         flex-direction: row;
         align-items: center;
         background-color: ${props => (props.theme['background--100'])};
         border-bottom: 1px solid ${props => (props.theme['border--100'])};
         padding: 0 20px;
         height: 40px;
         text-align: left;
         font-size: 12px;
         color: ${props => (props.theme['text--100'])};
         text-transform: uppercase;
         ${Theme.Functions.setFont('Inter', 600)};
     `,
    Content: styled.div`
         background-color: ${props => (props.theme['background--000'])};
         padding: 20px;
     `,
    Row: styled.div``
}

export const Line = {
    Row: styled.div`
         display: flex;
         flex-direction: row;
         align-items: center;
         justify-content: space-between;
         padding-bottom: 15px;
 
         &:last-of-type {
             padding-bottom: 0px;
         }
     `,
    Title: styled.div`
         text-align: left;
         font-size: 14px;
         color: ${props => (props.theme['text--100'])};
         ${Theme.Functions.setFont('Inter', 400)};
     `,
    Price: styled.div`
         font-size: 14px;
         ${Theme.Functions.setFont('Inter', 500)};
     `
}

export const Summary = {
    Base: styled.div`
         display: flex;
         flex-direction: column;
         justify-content: space-between;
         width: 100%;
     `,
    Total: {
        Base: styled.div`
             display: flex;
             flex-direction: row;
             justify-content: space-between;
             padding-top: 10px;
             border-top: 1px solid ${props => (props.theme['border--100'])};
         `,
        Title: styled.div`
             text-align: left;
             font-size: 14px;
             color: ${props => (props.theme['text--100'])};
             ${Theme.Functions.setFont('Inter', 400)};
         `,
        Price: styled.div`
             font-size: 24px;
             color: ${props => (props.theme['text--300'])};
             ${Theme.Functions.setFont('Inter', 700)};
         `
    },
    Actions: styled.div`
         display: flex;
         flex-direction: row;
         align-items: center;
         justify-content: space-between;
         padding: 0 15px 15px;
         background-color: ${props => (props.theme['background--000'])};
 
         button {
             width: 50%;
         }
     `,
    Details: styled.div`
         display: flex;
         flex-direction: column;
         justify-content: space-between;
         height: 100%;
         margin: 20px;
         padding: 15px;
         border-radius: 8px;
         border: 1px solid ${props => (props.theme['border--100'])};
     `
}

export const Method = {
    Credit: styled.div`
         display: flex;
         flex-direction: row;
         align-items: center;
         justify-content: space-between;
     `,
    Default: {
        Wrapper: styled.div`
             display: flex;
             flex-direction: row;
             width: 100%;
             align-items: center;
             height: 44px;
             padding: 0 15px;
             margin-bottom: 0;
             border-radius: 8px;
             border: 1px solid ${props => (props.theme['border--100'])};
 
             ${props => Theme.Functions.mediaBreakUp(props.theme['breakpoints-sm'])} {
                 margin-top: 20px;
             }
         `,
        Card: styled.label`
             width: 100%;
             text-align: left;
             font-size: 12px;
             color: ${props => (props.theme['text--300'])};
             ${Theme.Functions.setFont('Inter', 700)};
         `,
        Expiry: styled.label`
             text-align: right;
             font-size: 12px;
             color: ${props => (props.theme['text--300'])};
             ${Theme.Functions.setFont('Inter', 700)};
         `,
        Type: styled.div`
             svg {
                 height: 16px;
                 width: 2rem;
                 margin-right: 0.5rem;
             }
         `
    },
    Wrapper: styled.nav`
         display: flex;
         flex-direction: row;
         margin-bottom: 20px;
 
         ${props => Theme.Functions.mediaBreakUp(props.theme['breakpoints-sm'])} {
             margin-bottom: 0;
         }
     `,
    Option: {
        Wrapper: styled.div`
             cursor: pointer;
             position: relative;
             display: inline-flex;
             align-items: center;
             justify-content: space-between;
             width: 100%;
             height: 44px;
             padding: 10px 15px;
             border-radius: 8px;
             border: 1px solid ${props => (props.theme['border--100'])};
             ${Theme.Functions.animation('transition-all')};
 
             &.active {
                 border-color: ${props => (props.theme['confirm--100'])};
                 background-color: ${props => (Theme.Functions.hexToRGBA(props.theme['confirm--100'], '0.075'))};
 
                 label {
                     color: ${props => (props.theme['confirm--100'])};
                 }
 
                 &:hover {
                     border-color: ${props => (props.theme['confirm--100'])};
 
                     label {
                         color: ${props => (props.theme['confirm--100'])};
                     }
                 }
             }
 
             &:hover {
                 border-color: ${props => (props.theme['border--200'])};
 
                 label {
                     color: ${props => (props.theme['text--300'])};
                 }
             }
 
             > div {
                 position: absolute;
                 top: -8px;
                 right: -8px;
                 width: 18px;
             }
 
             &:first-of-type {
                 margin-right: 10px;
             }
         `,
        Label: styled.label`
             cursor: pointer;
             text-align: left;
             font-size: 12px;
             color: ${props => (props.theme['text--100'])};
             ${Theme.Functions.setFont('Inter', 700)};
             ${Theme.Functions.animation('transition-all')};
         `,
        Icon: {
            Wrapper: styled.div`
                 display: inline-flex;
                 align-items: center;
                 justify-content: center;
                 height: 16px;
                 width: 16px;
                 border-radius: 9999px;
                 background-color: ${props => (props.theme['confirm--100'])};
             `,
            Fade: styled(Fade)`
                 position: relative;
                 max-width: 16px;
                 height: 16px;
             `,
            Check: styled(CheckIcon)`
                 width: 12px;
                 color: ${props => (props.theme['white--100'])};
             `
        }
    }
}
